export default class GerenciamentoParametrosViewModel {
    constructor () {
        this.numeroSenha = undefined;
        this.numeroTentativas = undefined;
        this.numeroDiasLimpezaLog = undefined;
        this.nomeGrupo = undefined;
        this.id = undefined;
        this.sistemaGrupoId = undefined;
        this.usuarioId = undefined;
        this.usuario = undefined;
        this.cidades = undefined;
        this.acessos = undefined;
        this.transportadoras = undefined;
        this.comissoes = undefined;
        this.log = undefined;
        this.parametros = undefined;
        this.liberacaoRepresentante = undefined;
        this.usuariosLogados = undefined;
        this.condicoesPagamento = undefined;
        this.tapumeAtivo = false;
        this.formaPagamentoAutomacao = undefined;
        this.tipoFreteAutomacao = undefined;
        this.descricaoOnda = undefined;
        this.formaPagamentoId = undefined;
        this.parametroAutomacaoId = undefined;
    }

}